import { peekPendingSubtaskSelection, setPendingSubtaskSelection } from './pendingSubtaskSelection'

/** So viele Bilder lang wird gesucht (~1 s), wie beim Zeigen einer Aufgabe in der Liste. */
const MAX_FRAMES = 60

/**
 * **Eine eingehängte Aufgabe zeigen** (#204, Grill 7): Klickt man auf der Pinnwand das Eselsohr
 * ihres Zettels, klappt ihre Elternaufgabe in der Liste auf. Darin ist sie angefasst und im Bild.
 *
 * Je Bild, bis zu einer Sekunde: erst die Elternaufgabe auswählen (sie kann noch fehlen, etwa
 * hinter dem Geschafft-Schalter), dann einmal aufklappen, dann die Zeile ins Bild rollen.
 * Angefasst wird sie über die Vormerkung, die die Checkliste abholt.
 *
 * @param select wählt eine Aufgabe in der Liste aus; `false`, solange sie dort nicht steht
 * @param expand klappt sie auf
 * @returns Abbruch. Er nimmt die eigene, noch nicht abgeholte Vormerkung zurück — sonst nähme
 *   sich die nächste aufklappende Karte keinen Fokus.
 */
export function revealSubtask({ parentId, subtaskId, select, expand }: {
  parentId: string
  subtaskId: string
  select: (taskId: string) => boolean
  expand: (taskId: string) => void
}): () => void {
  setPendingSubtaskSelection(subtaskId)
  const mine = peekPendingSubtaskSelection()
  const rowSelector = `.task-entry--expanded [data-subtask-id="${CSS.escape(subtaskId)}"]`
  let frameId = 0
  let frames = 0
  let opened = false
  let done = false

  const stop = () => {
    done = true
    cancelAnimationFrame(frameId)
    if (peekPendingSubtaskSelection() === mine) setPendingSubtaskSelection(null)
  }

  const look = () => {
    if (!opened && select(parentId)) {
      opened = true
      expand(parentId)
    }
    const row = opened ? document.querySelector(rowSelector) : null
    if (row) {
      row.scrollIntoView({ behavior: 'smooth', block: 'center' })
      done = true
      return
    }
    if (++frames >= MAX_FRAMES) {
      stop()
      return
    }
    frameId = requestAnimationFrame(look)
  }
  frameId = requestAnimationFrame(look)

  return () => {
    if (!done) stop()
  }
}
